import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  constructor() { }
  currentSection = 'What is Asips?';

  ngOnInit(): void {

  }

  onSectionChange(sectionId: string) {
    if (sectionId === 'section1'){
      this.currentSection = 'What is Asips?';
    } else if (sectionId === 'section2'){
      this.currentSection = 'How to use Asips?';
    }else if (sectionId === 'section3'){
      this.currentSection = 'What Gaussian Hellinger EFDT?';
    }else if (sectionId === 'section4'){
      this.currentSection = 'How the Asips works?';
    }
  }

  scrollTo(section) {
    document.querySelector('#' + section)
      .scrollIntoView();
  }
}
